export class VerifyEmailResponseModel {
    signed_in: boolean;
    user_email: string;
    verification_jwt: string;
    verification_required: boolean;
}
